import type {
  RyftAccountTransactionsListWithCountResponseType,
  RyftAccountTransactionsListRequestType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementLedgerTransactions = (
  parameters: RyftAccountTransactionsListRequestType,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.RyftManagementLedgerTransactions,
      parameters,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "ryft-management/accounts/transactions/list-with-count",
        params: parameters,
      }).then(
        (response) =>
          apiV2AssertResponse<RyftAccountTransactionsListWithCountResponseType>(
            response,
          ).data,
      ),
    ...getDefaultQueryOptionsV2<RyftAccountTransactionsListWithCountResponseType>(
      {
        context: { scope: "supplier", user, business },
      },
    ),
  });
};
